module.exports = __webpack_public_path__ + "img/media1.e8d75056.png";